"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class ContactIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(4.000000, 6.000000)" },
                        React.createElement("path", { d: "M8.00145455,5.39107133 C8.00145455,5.39107133 14.8407273,0.000302097902 14.5461818,0.000302097902 L1.45527273,0.000302097902 C1.17381818,0.000302097902 8.00145455,5.39107133 8.00145455,5.39107133 Z" }),
                        React.createElement("path", { d: "M15.8285091,0.812794406 L8.21541818,7.09265455 C8.08596364,7.19385734 7.91287273,7.19385734 7.78341818,7.0918993 L0.189236364,0.782584615 C0.0721454545,0.99933986 0.000872727273,1.24479441 0.000145454545,1.51064056 L0.000145454545,9.81833287 C0.000872727273,10.6506126 0.653236364,11.3288224 1.45541818,11.3288224 L14.5448727,11.3288224 C15.3470545,11.3288224 15.9994182,10.6506126 16.0001455,9.81833287 L16.0001455,1.51064056 C16.0001455,1.25763357 15.9346909,1.0219972 15.8285091,0.812794406" }))))));
    }
}
exports.ContactIcon = ContactIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/contact.tsx
// module id = 2136
// module chunks = 0 1 2